var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditCredits.jinja');
require('./MemberProfileEditCredits.less');

require('jquery-ui/ui/widgets/sortable');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditCredits-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditCredits-buttons-button--save': 'saveEdit',
        'click .MemberProfileEditCredits-body-form-inputIcons-delete': 'deleteCredit',
        'click .MemberProfileEditCredits-body-form-inputIcons-edit': 'editItem',
        'click .MemberProfileEditCredits-info': 'onInfoClick'
    },

    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onResize', 'saveApi', 'getFormData', 'onEditCredit', 'onBodyClick');

        window.app.vent.on('MemberProfileEdit--editCredit', this.onEditCredit);

        if (!app.settings.isPhone) {
            this.creditsJsp = this.$('.MemberProfileEditCredits-body-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');

            this.creditsSortable = this.$('.MemberProfileEditCredits-body-form').sortable({
                handle: '.MemberProfileEditCredits-body-form-inputIcons-drag',
                scroll: true
            });

            this.scrollOnDrag = window.app.utils.scrollOnDrag({
                sortInstance: this.creditsSortable,
                scrollInstance: this.creditsJsp
            });
        }

        $(window).on('resize', this.onResize);
        this.onResize();

        Base.prototype.initialize.call(this, options);
    },


    onResize: function () {
        if (!app.settings.isPhone) {
            this.creditsJsp.reinitialise();
        }
    },


    deactivate: function (params) {
        $(window).off('resize', this.onResize);

        this.scrollOnDrag && this.scrollOnDrag.destroy();

        window.app.vent.off('MemberProfileEdit--editCredit', this.onEditCredit);

        return Base.prototype.deactivate.call(this, params);
    },


    onInfoClick: function (e) {
        if (app.settings.isDesktop) return;

        if ($(e.target).closest('.MemberProfileEditCredits-infoPopup').length) return;

        if ($(e.currentTarget).hasClass('MemberProfileEditCredits-info--active')) {
            this.closeAllInfoPopups();
        } else {
            this.closeAllInfoPopups();
            $(e.currentTarget).addClass('MemberProfileEditCredits-info--active');
            $('body').on('click', this.onBodyClick);
        }
    },


    closeAllInfoPopups: function () {
        this.$('.MemberProfileEditCredits-info').removeClass('MemberProfileEditCredits-info--active');

        $('body').off('click', this.onBodyClick);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.MemberProfileEditCredits-info').length) return;

        this.closeAllInfoPopups();
    },


    //message from add/edit popup after item edit
    onEditCredit: function (form) {
        var $idInput = this.$('input[name="id"][value="' + form.id + '"]');

        if (!$idInput.length) return;

        var $wrapper = $idInput.closest('.MemberProfileEditCredits-body-form-inputWrapper');

        $wrapper.find('input[name="season"]').val(form.season);
        $wrapper.find('input[name="role"]').val(form.role);

        $wrapper.find('.MemberProfileEditCredits-body-form-inputWrapper-infoSeason').html(form.season ? '<span>&nbsp;/&nbsp;</span>' + form.season : '');
        $wrapper.find('.MemberProfileEditCredits-body-form-inputWrapper-role').html(form.role);
    },


    saveEdit: function () {
        var self = this;
        var data = this.getFormData();

        var $button = this.$('.MemberProfileEditCredits-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                credits: data
            }),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updateCredits', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t add new credit!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'credits');
    },


    deleteCredit: function (e) {
        var $item = $(e.currentTarget).parents('.MemberProfileEditCredits-body-form-inputWrapper');

        $item.remove();

        if (!app.settings.isPhone) {
            this.creditsJsp.reinitialise();
        }
    },


    editItem: function (e) {
        var id = $(e.currentTarget).data('id');
        var data = this.getFormData();
        var item = _.findWhere(data, {id: id});

        window.app.vent.trigger('MemberProfileEdit--open', 'creditsEdit', false, item);
    },



    getFormData: function () {
        var self = this;
        var res = [];
        var order = 0;

        this.$('.MemberProfileEditCredits-body-form-inputWrapper').each(function () {
            var id = $('input[name="id"]', $(this)).val() - 0;
            var title = $('input[name="title"]', $(this)).val();
            var cover = $('input[name="cover"]', $(this)).val();
            var url = $('input[name="url"]', $(this)).val();
            var season = $('input[name="season"]', $(this)).val();
            var role = $('input[name="role"]', $(this)).val();

            cover = cover ? JSON.parse(cover) : null;

            var data = {
                'id': id,
                'title': title,
                'cover': cover,
                'url': url,
                'role': role,
                'season': season,
                'order': order++
            };

            res.push(data);
        });

        return res;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditCredits.js
// module id = 204
// module chunks = 0